import React from 'react'
import { useDispatch } from 'react-redux'
import { addToCart } from '../../redux/actions/cartAction'

const Card = ({details}) => {

  const dispatch = useDispatch()

  const addToCartHandler = () => {
    dispatch(addToCart(details, 1))
  }

  return (
    <div className="card mb-7">
    <div className="badge badge-dark card-badge card-badge-left text-uppercase">New</div>
    <div className="card-img">
      <a className="card-img-hover" href={`/collections/framed-art/products/${details.handle}`}>
        <img className="card-img-top card-img-back" src={details.variant_image} alt="..." />
        <img className="card-img-top card-img-front" src={details.variant_image} alt="..." />
      </a>
      <div className="card-actions">
        <span className="card-action">
          <button className="btn btn-xs btn-circle btn-white-primary" data-toggle="modal" data-target="#modalProduct">
            <i className="bi bi-eye" />
          </button>
        </span>
        <span className="card-action">
          <button className="btn btn-xs btn-circle btn-white-primary" onClick={addToCartHandler}>
            <i className="bi bi-cart" />
          </button>
        </span>
        <span className="card-action">
          <button className="btn btn-xs btn-circle btn-white-primary" data-toggle="button">
            <i className="bi bi-heart" />
          </button>
        </span>
      </div>
    </div>
    <div className="card-body px-0 text-center">
      <div className="font-weight-bold">
        <a className="text-body text-capitalize" href={`/collections/framed-art/products/${details.handle}`}>
          {details.title}
        </a>
      </div>
      <div className="font-weight-bold text-muted">
        <span className='text-danger '><s>Rs. {details.variant_compare_at_price}</s></span> <span className=''>From Rs. {details.variant_price}</span>
        <br />
        <span className='text-success'>Save Rs. {details.variant_compare_at_price-details.variant_price}</span>
      </div>
    </div>
  </div>
  )
}

export default Card